import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "d-none d-md-block col-12 col-md-9" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card mb-6" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Basic Information", -1)
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-lg-inline" }, "Changes", -1)
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "d-flex flex-column flex-md-row" }
const _hoisted_14 = { class: "d-flex justify-content-center justify-content-md-start mb-8 mb-md-0 me-md-8" }
const _hoisted_15 = {
  class: "mb-4",
  style: {"position":"relative","display":"inline-block","max-width":"200px","max-height":"200px"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "d-none btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow",
  style: {"left":"90%","top":"-10px","position":"absolute","z-index":"1"},
  title: "Change avatar"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pencil fs-7 text-gray-600" })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash fs-7 text-white" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "avatar-uploader-icon d-flex align-items-center justify-content-center"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-camera fa-1x" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip text-muted" }, " 200x200px size recommended ", -1)
const _hoisted_24 = { class: "d-flex row" }
const _hoisted_25 = { class: "col-12 col-md-6 col-lg-4" }
const _hoisted_26 = { class: "col-12 col-md-6 col-lg-4" }
const _hoisted_27 = { class: "col-12 col-md-6 col-lg-4" }
const _hoisted_28 = { class: "col-12 col-md-6" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-12 col-md-6" }
const _hoisted_31 = { class: "card" }
const _hoisted_32 = { class: "card-header" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Emergency Contacts", -1)
const _hoisted_34 = { class: "card-toolbar" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-xl-inline" }, "Contact", -1)
const _hoisted_36 = { class: "card-body card-scroll" }
const _hoisted_37 = { class: "col-12 col-md-6" }
const _hoisted_38 = { class: "card mb-6 mb-xl-9" }
const _hoisted_39 = { class: "card-header" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Contact Methods", -1)
const _hoisted_41 = { class: "card-toolbar" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-primary dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, " Add ", -1)
const _hoisted_43 = {
  class: "menu show menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_44 = {
  class: "card-body card-scroll h-250px p-0 highlight-block ph-no-capture",
  "data-openreplay-obscured": ""
}
const _hoisted_45 = { class: "table-responsive" }
const _hoisted_46 = {
  class: "table table-flush align-middle table-row-bordered table-row-solid gy-4 gs-9",
  "aria-label": "A list of all your email addresses and phone numbers."
}
const _hoisted_47 = { class: "fw-6 fw-bold text-gray-600" }
const _hoisted_48 = { class: "mb-1 text-gray-800" }
const _hoisted_49 = {
  class: "d-none d-md-flex justify-content-end",
  style: {"border-style":"none"}
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-trash fs-3 me-4" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "pulse-ring border-5" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-badge-check fs-3" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-star fs-3" }, null, -1)
const _hoisted_54 = { class: "w-50" }
const _hoisted_55 = { class: "mb-1 text-gray-800" }
const _hoisted_56 = {
  class: "d-none d-md-flex justify-content-end",
  style: {"border-style":"none"}
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "pulse-ring border-5" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-phone-plus fs-3" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-trash fs-3 me-4" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-sms fs-2 me-4" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-star fs-3" }, null, -1)
const _hoisted_62 = { class: "d-none d-md-block col-12 col-md-3" }
const _hoisted_63 = { class: "card mb-6 mb-xl-9" }
const _hoisted_64 = { class: "card-header" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Measurements", -1)
const _hoisted_66 = { class: "card-toolbar" }
const _hoisted_67 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserSettingsMenuMobile = _resolveComponent("UserSettingsMenuMobile")!
  const _component_Button = _resolveComponent("Button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_Selector2 = _resolveComponent("Selector2")!
  const _component_UserEmergencyContactsCard = _resolveComponent("UserEmergencyContactsCard")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_MeasurementSettings = _resolveComponent("MeasurementSettings")!
  const _component_PhoneNumberModal = _resolveComponent("PhoneNumberModal")!
  const _component_EmailAddressModal = _resolveComponent("EmailAddressModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UserSettingsMenuMobile),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Button, {
                  onClick: _ctx.update,
                  "is-loading": _ctx.isLoading,
                  class: "btn-sm"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Save "),
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["onClick", "is-loading"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        (_ctx.hasAvatar && !_ctx.photoIsLoading)
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 0,
                              class: "btn btn-icon btn-circle btn-danger btn-active-color-primary w-25px h-25px bg-danger shadow",
                              style: {"left":"90%","top":"80%","position":"absolute","z-index":"1"},
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.removePhoto && _ctx.removePhoto(...args))),
                              title: "Remove avatar"
                            }, _hoisted_18))
                          : _createCommentVNode("", true),
                        _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                          class: "avatar-uploader",
                          "show-file-list": false,
                          "on-success": _ctx.handleAvatarSuccess,
                          "before-upload": _ctx.beforeAvatarUpload,
                          "http-request": _ctx.requestCropper
                        }, {
                          default: _withCtx(() => [
                            (_ctx.hasAvatar)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.profile.avatar,
                                  class: "avatar",
                                  width: "200",
                                  height: "200",
                                  alt: ""
                                }, null, 8, _hoisted_19))
                              : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                          ]),
                          _: 1
                        }, 8, ["on-success", "before-upload", "http-request"])), [
                          [_directive_loading, _ctx.photoIsLoading]
                        ]),
                        _hoisted_23
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_InputGroup, {
                          "is-required": true,
                          "is-loading": _ctx.isFetching,
                          label: "First Name"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.profile.firstName.$error}]),
                              type: "text",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profile.firstName) = $event))
                            }, null, 2), [
                              [_vModelText, _ctx.profile.firstName]
                            ])
                          ]),
                          _: 1
                        }, 8, ["is-loading"]),
                        _createVNode(_component_InputGroup, {
                          "is-required": true,
                          "is-loading": _ctx.isFetching,
                          label: "Last Name"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.profile.lastName.$error}]),
                              type: "text",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profile.lastName) = $event))
                            }, null, 2), [
                              [_vModelText, _ctx.profile.lastName]
                            ])
                          ]),
                          _: 1
                        }, 8, ["is-loading"])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_InputGroup, {
                          "is-required": true,
                          "is-loading": _ctx.isFetching,
                          label: "Pronouns"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.profile.pronouns.$error}]),
                              type: "text",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profile.pronouns) = $event))
                            }, null, 2), [
                              [_vModelText, _ctx.profile.pronouns]
                            ])
                          ]),
                          _: 1
                        }, 8, ["is-loading"]),
                        _createVNode(_component_InputGroup, {
                          "is-required": true,
                          "is-loading": _ctx.isFetching,
                          label: "Birthdate"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.profile.birthdate.$error}]),
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.birthdate) = $event))
                            }, null, 2), [
                              [_vModelText, _ctx.birthdate]
                            ])
                          ]),
                          _: 1
                        }, 8, ["is-loading"])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_InputGroup, {
                          "is-required": true,
                          "is-loading": _ctx.isFetching,
                          label: "Title"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.profile.title.$error}]),
                              placeholder: "Stage Manager",
                              type: "text",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.profile.title) = $event))
                            }, null, 2), [
                              [_vModelText, _ctx.profile.title]
                            ])
                          ]),
                          _: 1
                        }, 8, ["is-loading"]),
                        _createVNode(_component_InputGroup, {
                          label: "Gender",
                          "is-required": true,
                          "is-loading": _ctx.isFetching
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Selector2, {
                              options: _ctx.genderOptions,
                              modelValue: _ctx.profile.genderIdentity,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.profile.genderIdentity) = $event))
                            }, null, 8, ["options", "modelValue"])
                          ]),
                          _: 1
                        }, 8, ["is-loading"])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_InputGroup, {
                          "is-loading": _ctx.isFetching,
                          label: "Allergies, Conditions & Dietary Restrictions",
                          tooltip: "This will be accessible to all managers & administrators of productions you are a member of."
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("textarea", {
                              class: "form-control highlight-block ph-no-capture",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.profile.medical) = $event)),
                              "data-openreplay-obscured": ""
                            }, null, 512), [
                              [_vModelText, _ctx.profile.medical]
                            ])
                          ]),
                          _: 1
                        }, 8, ["is-loading"])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_Button, {
                  class: "btn btn-primary btn-sm",
                  onClick: _ctx.invokeAddEmergencyContact
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Add "),
                    _hoisted_35
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_UserEmergencyContactsCard)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                (!_ctx.isCapacitor)
                  ? (_openBlock(), _createBlock(_component_Popper, { key: 0 }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("a", {
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.invokeAddEmail && _ctx.invokeAddEmail(...args))),
                            class: "dropdown-item",
                            style: {"padding":"0.85rem 1rem"},
                            href: "#"
                          }, "Email Address"),
                          _createElementVNode("a", {
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.invokeAddPhone && _ctx.invokeAddPhone(...args))),
                            class: "dropdown-item",
                            style: {"padding":"0.85rem 1rem"},
                            href: "#"
                          }, "Phone Number")
                        ])
                      ]),
                      default: _withCtx(() => [
                        _hoisted_42
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      onClick: _ctx.showAddContactMethodActionSheet,
                      class: "btn-sm"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Add")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("table", _hoisted_46, [
                  _createElementVNode("tbody", _hoisted_47, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profile.emailAddresses, (email) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: email.emailAddressId,
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showActionSheet && _ctx.showActionSheet(...args)))
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_48, _toDisplayString(email.email), 1)
                        ]),
                        _createElementVNode("td", _hoisted_49, [
                          (!email.isPrimary)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                onClick: ($event: any) => (_ctx.removeEmail(email.emailAddressId)),
                                class: "btn-link btn-icon me-lg-2 btn-active-color-danger",
                                type: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_50
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          (!email.isVerified)
                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: 1,
                                content: "Verify Email",
                                placement: "top"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Button, {
                                    onClick: ($event: any) => (_ctx.requestEmailVerification(email.emailAddressId)),
                                    type: "",
                                    class: "btn-link btn-icon btn-active-color-primary me-4 pulse"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_51,
                                      _hoisted_52
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_tooltip, {
                            content: `${email.isPrimary ? 'Primary' : 'Make Primary'}`,
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Button, {
                                onClick: ($event: any) => (_ctx.makeEmailPrimary(email)),
                                class: _normalizeClass(`btn-link btn-icon me-lg-2 btn-active-color-warning ${email.isPrimary ? 'btn-color-warning' : ''}`),
                                type: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_53
                                ]),
                                _: 2
                              }, 1032, ["onClick", "class"])
                            ]),
                            _: 2
                          }, 1032, ["content"])
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profile.phoneNumbers, (phone) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: phone.phoneNumberId,
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showActionSheet && _ctx.showActionSheet(...args)))
                      }, [
                        _createElementVNode("td", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.formatPhone(phone.number)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_56, [
                          (!phone.isVerified && phone.canReceiveTexts)
                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: 0,
                                content: "Verify Number",
                                placement: "top"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Button, {
                                    onClick: ($event: any) => (_ctx.requestPhoneVerification(phone)),
                                    type: "",
                                    class: "btn-link btn-icon btn-active-color-primary me-4 pulse pulse-primary"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_57,
                                      _hoisted_58
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createVNode(_component_Button, {
                            onClick: ($event: any) => (_ctx.removePhone(phone.phoneNumberId)),
                            class: "btn-link btn-icon me-lg-2 btn-active-color-danger",
                            type: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_59
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_el_tooltip, {
                            content: `${phone.canReceiveTexts ? 'Receives Texts' : 'Does Not Receive Texts'}`,
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Button, {
                                class: _normalizeClass(`btn-link btn-icon me-lg-2 ${phone.canReceiveTexts ? 'btn-color-info' : ''}`),
                                style: {"cursor":"default"},
                                type: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_60
                                ]),
                                _: 2
                              }, 1032, ["class"])
                            ]),
                            _: 2
                          }, 1032, ["content"]),
                          (phone.canReceiveTexts)
                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: 1,
                                content: `${phone.isPrimary ? 'Primary' : 'Make Primary'}`,
                                placement: "top"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Button, {
                                    onClick: ($event: any) => (_ctx.makePhonePrimary(phone)),
                                    class: _normalizeClass(`btn-link btn-icon me-lg-2 btn-active-color-warning ${phone.isPrimary ? 'btn-color-warning' : ''}`),
                                    type: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_61
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "class"])
                                ]),
                                _: 2
                              }, 1032, ["content"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.contactMethodsLoading]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _hoisted_65,
          _createElementVNode("div", _hoisted_66, [
            _createVNode(_component_Button, {
              onClick: _ctx.saveMeasurements,
              class: "btn-sm"
            }, {
              default: _withCtx(() => [
                _createTextVNode("save")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_67, [
          (_ctx.application.ui.user.mobileSettingsTab === 'unset')
            ? (_openBlock(), _createBlock(_component_MeasurementSettings, { key: 0 }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_PhoneNumberModal, {
      ref: "phoneNumberModal",
      onAdded: _ctx.fetch,
      onVerified: _ctx.fetch
    }, null, 8, ["onAdded", "onVerified"]),
    _createVNode(_component_EmailAddressModal, {
      ref: "emailAddressModal",
      onAdded: _ctx.fetch
    }, null, 8, ["onAdded"])
  ]))
}